import { PRESCRIPTION_TYPE_NO_PRESCRIPTION } from 'shared/consts/productTemplates'
import {
  RELEASE_TOGGLE_VARIANT_ATTTRIBUTES_ENABLED,
  VARIANT_ATTRIBUTES,
} from 'shared/experiments/consts'
import { isExperimentVariableTrue } from 'shared/experiments/utils/featureFlags'
import store from 'shared/store'
import { isMobile } from 'shared/utils/deviceClassUtils'
import { SELECT_ELEMENT } from 'views/assets/scripts/select'
import { CLIENTSIDE_HOOK_CHILDREN_WRAPPER } from 'views/containers/browser/ProductVariantsAttributesContainer/AttributePickers/AttributePickerRegionCollapsibleWrapper'

import { CONTACT_LENS_GROUP_ID } from './consts'

const VARIANT_ATTRIBUTES_BUTTON = '[name="variantAttribute"]'
const BUY_BOX_STICKY = '[data-clientside-hook="buy-box-sticky"]'
const PRESCRIPTION_SELECT = '[data-clientside-hook="h-ProductVariants-trigger"]'
const VARIANT_ATTRIBUTES_COLLAPSIBLE =
  '[data-clientside-hook="attributePicker-collapsible--label"]'

const VARIANT_ATTRIBUTES_SELECT_CONTAINER =
  '[data-clientside-hook="variant-attibute-select"]'
const VARIANT_ATTRIBUTES_SELECT = '[data-clientside-hook="select"]'

const SELECT_ELEMENT_OPTIONS = document.querySelectorAll(
  `[data-clientside-hook="variant-attibute-select"] .m-Select__list [role="listbox"] [role="option"]`
)

const SELECT_ELEMENT_SELECTED_ITEM = document.querySelector(
  `[data-clientside-hook="variant-attibute-select"] .m-Select__item__selected-item`
)
const SELECT_ELEMENT_SELECTED_ITEMS = document.querySelectorAll(
  `[data-clientside-hook="variant-attibute-select"] .m-Select__item__selected-item`
)

export default async () => {
  const {
    pageProperties: { experiments = [] },
  } = store.getPublicRuntimeConfig()

  const isVariantAttributeFlagSelected = isExperimentVariableTrue(
    VARIANT_ATTRIBUTES,
    RELEASE_TOGGLE_VARIANT_ATTTRIBUTES_ENABLED,
    experiments
  )

  isVariantAttributeFlagSelected && productVariantAttributesScript()
}

const productVariantAttributesScript = () => {
  const scrollToSelectedAttributes = () => {
    const selectedVariantAttributes = document.querySelectorAll(
      `.selectedVariantAttribute`
    )
    selectedVariantAttributes &&
      selectedVariantAttributes.forEach(element => {
        element.parentElement.parentElement.scrollTo({
          top: 0,
          left:
            element.getBoundingClientRect().left -
            (element.parentElement.parentElement.clientWidth -
              element.parentElement.clientWidth) /
              2,
          behavior: 'smooth',
        })
      })
  }
  isMobile(store.getPublicRuntimeConfig().publicConfig.deviceClass) &&
    scrollToSelectedAttributes()

  const variantAttributesButtons = [
    ...document.querySelectorAll(VARIANT_ATTRIBUTES_BUTTON),
  ]

  const notepadIcon = document.querySelector(
    '[data-clientside-hook=o-BuyBoxWishList__listItem]'
  )
  const prescriptionSelect = document.querySelector(
    `${PRESCRIPTION_SELECT} ${SELECT_ELEMENT}`
  )

  prescriptionSelect?.addEventListener('change', event => {
    toggleAddToNotepadIcon(event)
  })

  const toggleAddToNotepadIcon = event => {
    if (event.currentTarget.value === PRESCRIPTION_TYPE_NO_PRESCRIPTION) {
      notepadIcon.classList.remove('o-BuyBoxIconList__item--hide')
    } else {
      notepadIcon.classList.add('o-BuyBoxIconList__item--hide')
    }
  }

  const variantAttributeSelectsContainers = [
    ...document.querySelectorAll(VARIANT_ATTRIBUTES_SELECT_CONTAINER),
  ]
  const variantAttributeSelects = []
  variantAttributeSelectsContainers.forEach(element => {
    const selects = element.querySelector(VARIANT_ATTRIBUTES_SELECT)
    variantAttributeSelects.push(selects)
  })

  const urlSearchParams = new URLSearchParams(window.location.search)
  const params = Object.fromEntries(urlSearchParams.entries())
  const isMaster = params.master

  const applyButtonWrapper = document.getElementById('applyButtonWrapper')
  const applyButton = document.getElementById('applyButtonOnPDP')
  const addToCartElement = document.getElementById('addToCardButton')
  const stockStatus = document.getElementById('stockStatus')
  const topOfPickers = document.getElementById('topOfPickers')

  const buyBoxSticky = document.querySelector(BUY_BOX_STICKY)

  const selectProductVariantButtonDrawer = document.getElementById(
    'selectProductVariantButtonDrawer'
  )
  const variantAttributesMessagesContainer = document.getElementById(
    'variantAttributesMessagesContainer'
  )

  const configureProductMessage = document.getElementById(
    'configureProductMessage'
  )
  const selectAllVariantAttributesMessage = document.getElementById(
    'selectAllVariantAttributesMessage'
  )
  const noCombinationAvailableOptionMessage = document.getElementById(
    'noCombinationAvailableOptionMessage'
  )

  const initialCollapsible = [
    ...document.querySelectorAll(VARIANT_ATTRIBUTES_COLLAPSIBLE),
  ]

  let selectedVariants = {}
  let allVariantAttributes = []

  /**
   * fetch product from page props
   */
  const product = store.getPublicRuntimeConfig().pageProperties.product

  /**
   * get all variant attributes for this product
   */
  let hasPersonalAttribute = false
  product.variants.forEach(variant => {
    let currentVariant = {}
    variant.variantAttributes &&
      variant.variantAttributes.forEach(variantAttribute => {
        currentVariant[variantAttribute.variantCode] = variantAttribute.value
        if (variantAttribute.personal) {
          hasPersonalAttribute = variantAttribute.personal
        }
      })
    currentVariant['upid'] = variant.upid
    allVariantAttributes.push(currentVariant)
  })
  if (isMaster && hasPersonalAttribute) {
    variantAttributesMessagesContainer.style.visibility = 'visible'
    configureProductMessage.style.display = 'flex'
    buyBoxSticky?.classList.add('o-BuyBoxSticky--incomplete')
  }

  /**
   * Function to create array with currently selected variant, so other could be selected on click
   */
  const preselectedVariantAttributes = () => {
    const currentVariantId = product.upid
    const currentVariant = product.variants.find(
      variant => variant.upid === currentVariantId
    )
    currentVariant?.variantAttributes.map(variantAttribute => {
      selectedVariants[variantAttribute.variantCode] = variantAttribute.value
      selectedVariants['upid'] = currentVariantId
    })
  }

  const applyStylesToCurrentPicker = event => {
    event.target.closest('button').className += ' selectedVariantAttribute'
    const circleBadgeSelector = event.target
      .closest('button')
      .querySelector('.a-CircleBadge')
    circleBadgeSelector?.classList.add('a-CircleBadge--border')
    const darkColorSelector = event.target
      .closest('button')
      .querySelector('.u-color--dark')
    darkColorSelector?.classList.add('a-ListPrice--color--background')
  }

  const areAllSelected = () => {
    const selectedVariantAttributes = document.querySelectorAll(
      `.o-ProductVariantsAttributePicker.selectedVariantAttribute`
    )
    let numberOfSelectedOptions = 0
    let numberOfSingleValuesListAttributes = 0
    product.variantAttributes.forEach(variantAttribute => {
      if (
        variantAttribute.group === CONTACT_LENS_GROUP_ID &&
        !variantAttribute.complete
      ) {
        numberOfSingleValuesListAttributes++
      }
    })
    variantAttributeSelects.forEach(variantAttributeSelect => {
      if (variantAttributeSelect.selectedIndex > 0) {
        numberOfSelectedOptions++
      }
    })
    let numberOfVariantAttributes = 0

    Object.keys(allVariantAttributes[0]).forEach(key => {
      if (key !== 'upid') {
        numberOfVariantAttributes++
      }
    })
    return (
      selectedVariantAttributes.length +
        numberOfSelectedOptions +
        numberOfSingleValuesListAttributes ===
      numberOfVariantAttributes
    )
  }

  const isPossibleCombination = () => {
    return allVariantAttributes.some(variant => {
      const selectedVariantsKeys = Object.keys(selectedVariants)
      selectedVariants['upid'] = variant['upid']
      for (let key of selectedVariantsKeys) {
        if (selectedVariants[key] !== variant[key]) {
          return false
        }
      }
      return true
    })
  }
  const isSingleChangeableAttribute = () => {
    let numberOfMultipleValues = 0
    product.allAttributes.forEach(attribute => {
      if (attribute.type === 'LIST' || attribute.values.length > 1) {
        numberOfMultipleValues++
      }
    })
    return numberOfMultipleValues < 2
  }

  const updateDomWithCurrentData = (event, parentDiv) => {
    if (stockStatus && variantAttributesMessagesContainer) {
      stockStatus.hidden = true
      variantAttributesMessagesContainer.hidden = false
    }

    const resetAttributes = [
      ...document.querySelectorAll('[id ="' + parentDiv + '"]'),
    ]

    if (!isSingleChangeableAttribute()) {
      buyBoxSticky?.classList.add('o-BuyBoxSticky--incomplete')

      addToCartElement.hidden = true
      applyButtonWrapper.hidden = false
    }

    selectedVariants[parentDiv] = null
    resetAttributes.forEach(ele => {
      ele.classList.remove('selectedVariantAttribute')
      const circleBadgeElement = ele.querySelector('.a-CircleBadge')
      circleBadgeElement?.classList.remove('a-CircleBadge--border')
      circleBadgeElement?.classList.add('a-CircleBadge--border--transparent')
      const darkColorSelector = ele.querySelector('.u-color--dark')
      darkColorSelector?.classList.remove('a-ListPrice--color--background')
    })
    selectedVariants[parentDiv] = event.currentTarget.value
    if (isSingleChangeableAttribute()) {
      selectedVariants['upid'] =
        event.type === 'click'
          ? event.currentTarget.dataset.upid
          : SELECT_ELEMENT_SELECTED_ITEM.dataset.upid
      redirectToSelectedProduct()
    } else if (isPossibleCombination() && applyButton) {
      applyButton.disabled = false
    }
  }

  const redirectToSelectedProduct = () => {
    const variant = product.variants.find(
      productVariant => productVariant.upid === selectedVariants['upid']
    )
    window.location.href = window.location.origin + variant.path
  }

  preselectedVariantAttributes()

  const displaySelectionError = () => {
    const attributePickers = document.querySelectorAll(`.attributePickers`)
    attributePickers.forEach(attributePicker => {
      if (
        attributePicker.querySelector(
          '.o-ProductVariantsAttributePicker.selectedVariantAttribute'
        ) === null
      ) {
        const errorAttributePickers = attributePicker.querySelectorAll(
          '.o-ProductVariantsAttributePicker'
        )
        errorAttributePickers.forEach(variantAttributeValue => {
          variantAttributeValue.classList.add('errorVariantAttribute')
        })
      }
    })
    variantAttributeSelects.forEach(variantAttributeSelect => {
      variantAttributeSelect.selectedIndex === 0 &&
        variantAttributeSelect.parentElement.parentElement
          .querySelector('.m-Select__inner')
          .classList.add('errorVariantAttribute')
    })
  }

  const hideSelectionError = () => {
    document
      .querySelectorAll(`.errorVariantAttribute`)
      .forEach(variantValue => {
        variantValue.classList.remove('errorVariantAttribute')
      })
  }
  const hideAllMessages = () => {
    if (
      configureProductMessage &&
      selectAllVariantAttributesMessage &&
      noCombinationAvailableOptionMessage
    ) {
      configureProductMessage.style.display = 'none'
      selectAllVariantAttributesMessage.style.display = 'none'
      noCombinationAvailableOptionMessage.style.display = 'none'
    }
  }

  const toggleErrorMessages = (applyClicked = false) => {
    if (isMaster) {
      if (areAllSelected()) {
        hideSelectionError()
        hideAllMessages()

        if (!isPossibleCombination() && applyClicked) {
          noCombinationAvailableOptionMessage.style.display = 'flex'
        } else {
          configureProductMessage.style.display = 'flex'
        }
      } else {
        hideAllMessages()
        if (applyClicked) {
          displaySelectionError()
          selectAllVariantAttributesMessage.style.display = 'flex'
        } else {
          hideSelectionError()
          configureProductMessage.style.display = 'flex'
        }
      }
    } else {
      if (variantAttributesMessagesContainer) {
        variantAttributesMessagesContainer.style.visibility = 'visible'
      }

      isPossibleCombination()
        ? hideAllMessages()
        : applyClicked &&
          (noCombinationAvailableOptionMessage.style.display = 'flex')
    }
  }
  const getButtonColorVlaue = clickedButton => {
    const buttonValue = clickedButton.value
    const hasColor = clickedButton.value.includes('#')
    let splitedValue = ['']
    if (hasColor) {
      splitedValue = buttonValue.split('#')
      return {
        colorHex: splitedValue[1],
        colorLabel: splitedValue[0],
      }
    } else {
      return {
        colorHex: '',
        colorLabel: buttonValue,
      }
    }
  }

  const updateColorSelectedLabel = (labelElement, clickedButton) => {
    const selectedColor = getButtonColorVlaue(clickedButton)

    if (selectedColor.colorHex) {
      labelElement.children[0].children[0].classList.add('colorPickerColor')
      labelElement.children[0].children[1].classList.add(
        'o-buttonValueDisplay-margin'
      )
      labelElement.children[0].children[0].style.display = 'flex'
      labelElement.children[0].children[0].style.backgroundColor = `#${selectedColor.colorHex}`
      labelElement.parentElement.classList.remove(
        'o-variantAttributesContainerWrapper-label-baseline'
      )
    } else {
      labelElement.children[0].children[0].classList.remove('colorPickerColor')
      labelElement.children[0].children[1].classList.add(
        'o-buttonValueDisplay-margin'
      )
      labelElement.children[0].children[0].style.display = 'none'
      labelElement.children[0].children[0].style.backgroundColor = ``
    }
    labelElement.children[0].children[1].innerHTML = selectedColor.colorLabel
  }

  const updateSelectedLabel = (regionValueElement, closestButton) => {
    if (regionValueElement.childElementCount) {
      regionValueElement.children[0].innerHTML = closestButton.value
    } else {
      regionValueElement.innerHTML = closestButton.value
    }
  }

  const updateCollapsableSelectedLabel = event => {
    const closestRegion = event.target.closest('.attributeRegion')
    const closestButton = event.target.closest('button')
    const regionValueElement = closestRegion.children[0].children[0]
    closestButton.id === 'color_number'
      ? updateColorSelectedLabel(regionValueElement, closestButton)
      : updateSelectedLabel(regionValueElement, closestButton)
  }

  const handlePickerClick = event => {
    const isClickEventType = event.type === 'click'
    let parentDivId
    if (isClickEventType) {
      parentDivId = event.target.closest('button').id
    } else {
      parentDivId = event.target.id
    }

    if (
      isSingleChangeableAttribute() &&
      selectedVariants['upid'] === event.currentTarget.dataset.upid &&
      !isMaster
    ) {
      toggleErrorMessages(false)
      return
    }

    isClickEventType && updateCollapsableSelectedLabel(event)
    updateDomWithCurrentData(event, parentDivId)

    isClickEventType && applyStylesToCurrentPicker(event)

    areAllSelected() &&
      markNonExistingAndOutOfStockCombinations(
        product,
        selectedVariants,
        allVariantAttributes
      )
    toggleErrorMessages(false)
  }

  const toggleCollapsible = e => {
    const parent = e.target.closest('.attributeRegion')
    const clickedCollapsible = e.target.closest(
      '.o-ProductVariantsAttributePicker-Collapsible'
    )
    const variantWrapper = parent.querySelector(
      `[data-clientside-hook="${CLIENTSIDE_HOOK_CHILDREN_WRAPPER}"]`
    )

    if (clickedCollapsible.dataset.currentState === 'closed') {
      variantWrapper.classList.remove(
        'o-ProductVariantsAttributePicker-pill-teaser',
        'o-ProductVariantsAttributePicker-hide',
        'o-ProductVariantsAttributePicker-tile-teaser',
        'o-ProductVariantsAttributePicker-tile-teaser-unitPrice'
      )
      clickedCollapsible.dataset.currentState = ''
      clickedCollapsible.querySelector('svg').style.transform = 'rotate(180deg)'
      clickedCollapsible.querySelector('.m-TextWithIcon__text').innerHTML =
        clickedCollapsible.dataset.transClose
    } else {
      parent.children[0].scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
      variantWrapper.classList.add('o-ProductVariantsAttributePicker-hide')
      clickedCollapsible.dataset.currentState = 'closed'
      clickedCollapsible.querySelector('svg').style.transform = 'none'
      clickedCollapsible.querySelector('.m-TextWithIcon__text').innerHTML =
        clickedCollapsible.dataset.transOpen
    }
  }
  const handleApplyButtonClick = () => {
    isPossibleCombination() && areAllSelected()
      ? redirectToSelectedProduct()
      : toggleErrorMessages(true)

    areAllSelected() &&
      markNonExistingAndOutOfStockCombinations(
        product,
        selectedVariants,
        allVariantAttributes
      )
  }

  initialCollapsible?.forEach(element =>
    element.addEventListener('click', e => {
      toggleCollapsible(e)
    })
  )

  variantAttributesButtons.forEach(button => {
    button.addEventListener('click', e => {
      handlePickerClick(e)
    })
  })
  applyButton?.addEventListener('click', () => {
    handleApplyButtonClick()
  })
  selectProductVariantButtonDrawer?.addEventListener('click', () => {
    window.scrollTo({
      top:
        topOfPickers.getBoundingClientRect().top +
        window.scrollY -
        document.getElementsByClassName('o-HeaderSmall__menu--noSearchBox')[0]
          ?.offsetHeight,
      behavior: 'smooth',
    })
  })

  variantAttributeSelects?.forEach(select => {
    select.addEventListener('change', e => {
      handlePickerClick(e)
    })
  })
}

const markNonExistingAndOutOfStockCombinations = (
  product,
  selectedVariants,
  allVariantAttributes
) => {
  const buyableVariant = {}
  const notBuyableVariant = {}

  const availableVariants = product.variants.filter(variant => {
    return (
      variant.stockStatus?.statusReason === 'general.label.product.available'
    )
  })

  //add all variant options as grayedOut
  Object.keys(selectedVariants).forEach(key => {
    notBuyableVariant[key] = []
    allVariantAttributes.forEach(variant => {
      if (!notBuyableVariant[key].includes(variant[key])) {
        notBuyableVariant[key].push(variant[key])
      }
    })
  })

  //based on the current combination, calculate buyable variant values
  Object.keys(selectedVariants).forEach(key => {
    buyableVariant[key] = []
    const tempSelectedVariant = { ...selectedVariants }
    delete tempSelectedVariant['upid']
    availableVariants.forEach(availableVariant => {
      let exist = true
      let value = ''
      availableVariant.variantAttributes.forEach(availableVariantAttribute => {
        if (
          availableVariantAttribute.variantCode !== key &&
          tempSelectedVariant[availableVariantAttribute.variantCode] !==
            availableVariantAttribute.value
        ) {
          exist = false
        }
        if (availableVariantAttribute.variantCode === key) {
          value = availableVariantAttribute.value
        }
      })
      if (exist) {
        buyableVariant[key].push(value)
      }
    })
  })

  //remove grayedOut class from buyable
  for (const [key, value] of Object.entries(buyableVariant)) {
    value.forEach(singleBuyableVariant => {
      notBuyableVariant[key] = notBuyableVariant[key].filter(
        notBuyableVariant => notBuyableVariant !== singleBuyableVariant
      )

      const elements = document.querySelectorAll(
        `[data-qa-id="attributePicker-${key}"][value="${singleBuyableVariant}"]`
      )
      SELECT_ELEMENT_SELECTED_ITEMS.forEach(element => {
        if (element && element.innerHTML === singleBuyableVariant) {
          element.classList.remove('u-color--grey')
        }
      })
      SELECT_ELEMENT_OPTIONS &&
        SELECT_ELEMENT_OPTIONS.forEach(drop => {
          if (drop.dataset.value === singleBuyableVariant) {
            drop.classList.remove('u-color--grey')
          }
        })

      if (elements.length > 0) {
        elements[0].classList.remove('grayedOutVariantAttribute')
      }
    })
  }

  //add grayedOut class to notBuyable
  for (const [key, value] of Object.entries(notBuyableVariant)) {
    value.forEach(singleBuyableVariant => {
      notBuyableVariant[key] = notBuyableVariant[key].filter(
        notBuyableVariant => notBuyableVariant !== singleBuyableVariant
      )
      const elements = document.querySelectorAll(
        `[data-qa-id="attributePicker-${key}"][value="${singleBuyableVariant}"]`
      )
      SELECT_ELEMENT_SELECTED_ITEMS.forEach(element => {
        if (element && element.innerHTML === singleBuyableVariant) {
          element.classList.add('u-color--grey')
        }
      })
      SELECT_ELEMENT_OPTIONS &&
        SELECT_ELEMENT_OPTIONS.forEach(drop => {
          if (drop.dataset.value === singleBuyableVariant) {
            drop.classList.add('u-color--grey')
          }
        })

      if (elements.length > 0) {
        elements[0].classList.add('grayedOutVariantAttribute')
      }
    })
  }
}
